// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"564855676feb8cff","777":"ff8c4ac9f317c2c9"}[chunkId] + ".js";
};